import { Component, OnInit,ViewChild,ElementRef } from '@angular/core'; 
import { FormGroup,FormControl,FormArray,Validators } from '@angular/forms';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import {UtilsService} from '../common/services/utils.service';
import { Router } from '@angular/router';
import * as $ from 'jquery';
declare var hide_trade_entity_box2: Function;
declare var show_okshan_alert: Function;
declare var set_signup_range_from_to: Function;
declare var show_joinus_preference_input: Function;
declare var set_multi_select: Function;
declare var show_okshan_alert2: Function;
declare var show_okshan_alert3: Function;



@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {  

  regMobileNoFormdata;
  regMobileNo;
  regMobileNoOtp;
  regMobileNoSendOtpBtnLbl:string="Send OTP";
  regTerm; 
  requestInProcess:boolean=false;
  isLoading:boolean=true;

  registerationFormGroup;
  registerationFullName;
  registerationLastName;
  registerationDealerShipName;
  registerationDealerShipCity;
  registerationDealerShipState;
  registerationPin; 
  registerationAddress; 
  registerationEmail;
  registerationMobileNo;
  regMobileOtp;
  registerationTradeEntity;
  registerationIndName;
  registerationIndPhoneNo;
  registerationIndAlternateNo;
  registerationIndEmail;
  registerationIndPan;
  registerationIndGstno;
  registerationIndPanFile="";
  registerationIndAadhaarFile="";
  registerationIndPassportFile="";
  registerationIndDLFile="";
  registerationIndVoterFile="";
  registerationIndPhotoFile="";
  registerationIndBusinessProofFile="";
  registerationProTradeName;
  registerationProNo;
  registerationProName;
  registerationProPhoneNo;
  registerationProAlternateNo;
  registerationProEmail;
  registerationProPan;
  registerationProGstNo;
  registerationProPanFile="";
  registerationProAadhaarFile="";
  registerationProPassportFile="";
  registerationProDLFile="";
  registerationProVoterFile="";
  registerationProPhotoFile="";
  registerationProBusinessProofFile="";
  registerationParName;
  registerationParPartnerName;
  registerationParPhoneNo;
  registerationParAlternateNo;
  registerationParPan;
  registerationParEmail;
  registerationParPanFile="";
  registerationParGstFile="";
  registerationParBusinessProofFile="";
  registerationParPartnershipProofFile="";
  registerationParPhotoFile="";
  registerationParPan2File="";
  registerationParAddressProofFile="";
  registerationParAuthorityLetterFile="";
  registerationLimName;
  registerationLimPartnerName;
  registerationLimPhoneNo;
  registerationLimAlternateNo;
  registerationLimRocNo;
  registerationLimRocDate;
  registerationLimPan;
  registerationLimGstno;
  registerationLimPanFile="";
  registerationLimGstFile="";
  registerationLimCertificateFile="";
  registerationLimBusinessProofFile="";
  registerationLimPartnershipProofFile="";
  registerationLimPhotoFile="";
  registerationLimPan2File="";
  registerationLimAddressProofFile="";
  registerationLimAuthorityFile="";
  registerationPriName;
  registerationPriPartnerName;
  registerationPriPhoneNo;
  registerationPriAlternateNo;
  registerationPriRocNo;
  registerationPriRocDate;
  registerationPriPanNo;
  registerationPriGstNo;
  registerationPriPanFile="";
  registerationPriGstFile="";
  registerationPriCertificateFile="";
  registerationPriBusinessProofFile="";
  registerationPriArticlesFile="";
  registerationPriPhotoFile="";
  registerationPripan2File="";
  registerationPriAddressProofFile="";
  registerationPriResolutionFile="";
  registerationCancelChequeFile="";
  registerationPrefferedState;
  registerationPriceRangeFrom;
  registerationPriceRangeTo;
  registerationBrand;
  registerationCreditCardName;
  registerationCreditCardNo;
  registerationCreditCardExpiryMonth;
  registerationCreditCardExpiryYear;
  registerationDebitCardName;
  registerationDebitCardno;
  registerationDebitCardExpiryMonth;
  registerationDebitCardExpiryYear;
  registerationBankName;
  registerationBankIfsc;
  registerationBankAddress;
  registerationBankAccountNo;
  registerationPassword;
  registerationConfirmPassword;

  registerationPrefferedStatesArray=[];
  registerationBrandsArray = [];

  RegisterationFormData = new FormData();

  loginCredentialsFormGroup;
  loginCredentialsUser;
  loginCredentialsPassword;

  loginMobileNoFormGroup;
  loginMobileNo;
  loginMobileNoOtp;
  loginMobileNoSendOtpBtnLbl:string="Send OTP";

  forgotPasswordFormGroup;
  isSubmitForgotPassword:boolean=false;
  forgotPasswordBTNLabel:string='Send';

  sessionLoginStatus:boolean=false;
  sessionId:number=0;
  sessionFirstName:string='';
  sessionLastName:string='';
  sessionProfilePic:string='';
  sessionEmailId:string='';
  sessionMobileNo:string='';
  sessionDealershipName:string='';
  sessionProfileType:number=0;
  sessionStatus:number=0;
  sessionCityId:number=0;
  sessionStateId:number=0;

  isOtpConfirmed:boolean=false;
  eventStatusMsg:string='';
  getOtpBtnStatus:boolean=true;
  getOtpTryCount:number=0;
  counter:number=0;
  docStatus:number=0;
  counterLabel:string='';
  otpConfimedLabel:string="Verify otp";
  stateList=[];
  preferredStateList=[];
  otherStateList=[];
  cityList=[
    {"id":0,name:"Select state first"}
  ];
  preferredStateIds="";
  setStateChangeStatus:boolean=false;
  selectedState:string='';
  selectedCity:string='';

  @ViewChild('registrationBoxBtn') registrationBoxBtn: ElementRef;
  @ViewChild('loginModalCloseBtn') loginModalCloseBtn: ElementRef;
  @ViewChild('openLoginMobileOtpConfirmBoxBtn') openLoginMobileOtpConfirmBoxBtn: ElementRef;
  @ViewChild('rangeTo') rangeTo: ElementRef;
  @ViewChild('rangeFrom') rangeFrom: ElementRef;
  @ViewChild('registrationBoxCloseBtn') registrationBoxCloseBtn: ElementRef;
  @ViewChild('selectedPreferredState') selectedPreferredState: ElementRef;  

  constructor(private httpserviceService:HttpserviceService,
  private sessionsService:SessionsService, 
  private utilsService:UtilsService,
  private router:Router) 
  { 
    
  }

  ngOnInit(): void 
  {
    if(this.sessionsService.getSession("login_status")!=null)
    {
       this.sessionLoginStatus=this.sessionsService.getSession("login_status");
    } 
    if(this.sessionsService.getSession("id")!=null)
    {
       this.sessionId=this.sessionsService.getSession("id");
    }
    if(this.sessionsService.getSession("first_name")!=null)
    {
       this.sessionFirstName=this.sessionsService.getSession("first_name");
    }  
    if(this.sessionsService.getSession("last_name")!=null)
    {
       this.sessionLastName=this.sessionsService.getSession("last_name");
    }  
    if(this.sessionsService.getSession("profile_pic")!=null)
    {
       this.sessionProfilePic=this.sessionsService.getSession("profile_pic");
    }  
    if(this.sessionsService.getSession("email_id")!=null)
    {
       this.sessionEmailId=this.sessionsService.getSession("email_id");
    }  
    if(this.sessionsService.getSession("mobile_no")!=null)
    {
       this.sessionMobileNo=this.sessionsService.getSession("mobile_no");
    }  
    if(this.sessionsService.getSession("dealership_name")!=null)
    {
       this.sessionDealershipName=this.sessionsService.getSession("dealership_name");
    }  
    if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    if(this.sessionsService.getSession("status")!=null)
    {
       this.sessionStatus=this.sessionsService.getSession("status");
    } 
    if(this.sessionsService.getSession("city_id")!=null)
    {
       this.sessionCityId=this.sessionsService.getSession("city_id");
    }
    if(this.sessionsService.getSession("state_id")!=null)
    {
       this.sessionStateId=this.sessionsService.getSession("state_id");
    }

    this.regMobileNoFormdata=new FormGroup(
      {
        regMobileNo: new FormControl("",[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"),Validators.maxLength(10)]),
        regMobileNoOtp: new FormControl("",[Validators.required]),
        regTerm: new FormControl(false,[Validators.required])
      }
    );
 
      this.registerationFormGroup=new FormGroup(
       {           
          registerationFullName: new FormControl(this.sessionFirstName,[Validators.required]),
          registerationLastName: new FormControl(this.sessionLastName),
          registerationDealerShipName: new FormControl(this.sessionDealershipName),
          registerationDealerShipCity: new FormControl(this.sessionCityId,Validators.min(1)),
          registerationDealerShipState: new FormControl(this.sessionStateId,Validators.min(1)),
          registerationPin: new FormControl('',[Validators.required,Validators.maxLength(6)]),
          registerationAddress: new FormControl('',[Validators.required]),         
          registerationEmail: new FormControl(this.sessionEmailId,[Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
          registerationTerm: new FormControl(false,[Validators.required]),
          registerationMobileNo: new FormControl(this.sessionMobileNo.replace("+91",""),[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"),Validators.maxLength(10)]),
          regMobileOtp: new FormControl('',[Validators.required]),
          registerationTradeEntity: new FormControl('0',Validators.min(1)),
          registerationIndName: new FormControl('',[Validators.required]),
          registerationIndPhoneNo: new FormControl('',[Validators.required]),
          registerationIndAlternateNo: new FormControl(''),
          registerationIndEmail: new FormControl('',[Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
          registerationIndPan: new FormControl(''),
          registerationIndGstno: new FormControl(''),
          registerationProTradeName: new FormControl('',[Validators.required]),
          registerationProNo: new FormControl('',[Validators.required]),
          registerationProName: new FormControl('',[Validators.required]),
          registerationProPhoneNo: new FormControl('',[Validators.required]),
          registerationProAlternateNo: new FormControl(''),
          registerationProEmail: new FormControl('',[Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
          registerationProPan: new FormControl(''),
          registerationProGstNo: new FormControl(''),
          registerationParName: new FormControl('',[Validators.required]),
          registerationParPartnerName: new FormControl('',[Validators.required]),
          registerationParPhoneNo: new FormControl('',[Validators.required]),
          registerationParAlternateNo: new FormControl(''),
          registerationParPan: new FormControl(''),
          registerationParEmail: new FormControl(''),
          registerationLimName: new FormControl('',[Validators.required]),
          registerationLimPartnerName: new FormControl('',[Validators.required]),
          registerationLimPhoneNo: new FormControl('',[Validators.required]),
          registerationLimAlternateNo: new FormControl(''),
          registerationLimRocNo: new FormControl(''),
          registerationLimRocDate: new FormControl(''),
          registerationLimPan: new FormControl(''),
          registerationLimGstno: new FormControl(''),
          registerationPriName: new FormControl('',[Validators.required]),
          registerationPriPartnerName: new FormControl('',[Validators.required]),
          registerationPriPhoneNo: new FormControl('',[Validators.required]),
          registerationPriAlternateNo: new FormControl(''),
          registerationPriRocNo: new FormControl(''),
          registerationPriRocDate: new FormControl(''),
          registerationPriPanNo: new FormControl(''),
          registerationPriGstNo: new FormControl(''),
          registerationPrefferedState: new FormArray([]),
          registerationPriceRangeFrom: new FormControl(''),
          registerationPriceRangeTo: new FormControl(''),
          registerationBrand:  new FormArray([]),
          registerationCreditCardName: new FormControl(''),
          registerationCreditCardNo: new FormControl(''),
          registerationCreditCardExpiryMonth: new FormControl(''),
          registerationCreditCardExpiryYear: new FormControl(''),
          registerationDebitCardName: new FormControl(''),
          registerationDebitCardno: new FormControl(''),
          registerationDebitCardExpiryMonth: new FormControl(''),
          registerationDebitCardExpiryYear: new FormControl(''),
          registerationBankName: new FormControl(''),
          registerationBankIfsc: new FormControl(''),
          registerationBankAddress: new FormControl(''),
          registerationBankAccountNo: new FormControl(''),
          registerationPassword: new FormControl('',[Validators.required,Validators.minLength(8)]),
          registerationConfirmPassword: new FormControl('',[Validators.required])
       }
     );
    this.registerationPrefferedStatesArray.forEach((o, i) => {
const control = new FormControl(); // if first item set to true, else false
(this.registerationFormGroup.controls.registerationPrefferedState as FormArray).push(control);
});
this.registerationBrandsArray.forEach((o, i) => {
const control = new FormControl(); // if first item set to true, else false
(this.registerationFormGroup.controls.registerationBrand as FormArray).push(control);
});


    this.loginCredentialsFormGroup= new  FormGroup( 
      {
      loginCredentialsUser: new FormControl("",[Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
      loginCredentialsPassword: new FormControl("",[Validators.required])
      }
    );

    this.loginMobileNoFormGroup=new FormGroup(
      {
        loginMobileNo: new FormControl("",[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"),Validators.maxLength(10)]),
        loginMobileNoOtp: new FormControl("",[Validators.required])        
      }
    );

    this.forgotPasswordFormGroup= new  FormGroup( 
      {
      forgotPasswordEmailId: new FormControl("",[Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
      }
    );

   const interval = setInterval(() => {
    if (this.sessionsService.getSession('auth_user') != null ) {
    if (this.sessionsService.getSession('state_list') == null ) {
    this.getStateList();
    }
    else
    {      
      setTimeout(() => {   
    if(this.sessionStateId>0)
    {
    this.registerationFormGroup.controls['registerationDealerShipState'].setValue(this.sessionStateId);
    this.onChangeState(this.sessionStateId);
    }  
    }, 200);
    }
    if (this.sessionsService.getSession('state_city_list') == null ) {
    this.getStateCityList();
    }
    else
    {   
    setTimeout(() => {
    if(this.sessionCityId>0)
    {
    this.registerationFormGroup.controls['registerationDealerShipCity'].setValue(this.sessionCityId);   
    }  
    }, 200); 
    }
    if (this.sessionsService.getSession('brand_list') == null ) {
    this.getBrandList();
    }
    // if (this.sessionsService.getSession('all_brand_list') == null ) {
    // this.getAllBrandList();
    // }
    // if (this.sessionsService.getSession('all_model_list') == null ) {
    // this.getAllModelList();
    // }
    // if (this.sessionsService.getSession('all_variant_list') == null ) {
    // this.getAllVariantList(); 
    // }
    // if (this.sessionsService.getSession('all_city') == null ) {
    //   this.getAllCityList();
    // }
    // if (this.sessionsService.getSession('all_state') == null ) {
    //   this.getAllStateList();
    // }
    // if (this.sessionsService.getSession('fuel_type') == null || this.sessionsService.getSession('all_fuel_type') == null) {
    // this.getFuelTypeList();
    // }
    //if (this.sessionsService.getSession('all_brand_list') == null || this.sessionsService.getSession('all_model_list') == null || 
    //this.sessionsService.getSession('all_variant_list') == null || this.sessionsService.getSession('all_city') == null || 
    //this.sessionsService.getSession('all_state') == null || this.sessionsService.getSession('all_fuel_type') == null)
    //{
    this.getAllTypeList()
    //}    
      clearInterval(interval);      
    }       
  }, 100);
    
    if(this.sessionsService.getSession('state_list') != null)
   {
     this.stateList=this.sessionsService.getSession('state_list');
     this.registerationPrefferedStatesArray=this.sessionsService.getSession('state_list');       
       this.registerationPrefferedStatesArray.forEach((o, i) => {
const control = new FormControl(false); // if first item set to true, else false
(this.registerationFormGroup.controls.registerationPrefferedState as FormArray).push(control);
});
this.onChangeState(this.sessionStateId);

for(let i=0;i<this.stateList.length;i++)
{
  if(this.stateList[i].preferred==1)
  {
    this.preferredStateList.push(this.stateList[i]);
    this.preferredStateIds=this.preferredStateIds+"^"+this.stateList[i].id;
  }
  else
  {
    this.otherStateList.push(this.stateList[i]);
  }
}
setTimeout(() => {
set_multi_select();
}, 200);

   }

   if(this.sessionsService.getSession('brand_list') != null)
   {
     this.registerationBrandsArray=this.sessionsService.getSession('brand_list');
       this.registerationBrandsArray.forEach((o, i) => {
      const control = new FormControl(false); // if first item set to true, else false
      (this.registerationFormGroup.controls.registerationBrand as FormArray).push(control);
      });
   }

   setTimeout(() => {
      hide_trade_entity_box2();
      set_signup_range_from_to();
      //set_multi_select();
    }, 200);

  }

  /** sendRegOtpOnMobile function used to send registration otp on mobile*/   
  sendRegOtpOnMobile(data)
  {     
     this.regMobileNo=data.regMobileNo;
     this.registerationFormGroup.controls['registerationMobileNo'].setValue("+91"+data.regMobileNo);
     if(!this.regMobileNoFormdata.get('regMobileNo').errors){ 
     console.log('regMobileNo ------ '+this.regMobileNo)
     this.regMobileNoSendOtpBtnLbl="Resend OTP";
     this.isLoading=false;
     this.httpserviceService.sendRegOtpOnMobileNo("+91"+this.regMobileNo).
     pipe(retry(0)).
     subscribe((data)=>this.sendRegOtpOnMobileNoResponse(data),
     err => {
       show_okshan_alert('Something went wrong');
       console.log('Something went wrong', err);
       this.isLoading=true;
    })
     }
  }

  sendRegOtpOnMobileNoResponse(response)
  {
    console.log('sendRegOtpOnMobileNoResponse '+ response.status);
    if(response.status==="success")  
     {
     this.isLoading=true; 
     }
     else
     {
     show_okshan_alert(response.reason);
     this.isLoading=true;
     } 
  }
  
  /** confirmRegOtpOnMobile function used to confirm registration otp  */
  confirmRegOtpOnMobile(data)
  {

     this.regMobileNoOtp=data.regMobileNoOtp;
     if(!this.regMobileNoFormdata.get('regMobileNoOtp').errors && !this.regMobileNoFormdata.get('regTerm').errors){ 
     console.log('regMobileNoOtp ------ '+this.regMobileNoOtp)
     this.isLoading=false;
     let result =this.httpserviceService.confirmRegOtpOnMobileNo(this.regMobileNoOtp).
     pipe(retry(0)).
     subscribe((data)=>this.confirmRegOtpOnMobileResponse(data),
     err => {
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })       
  }
  }

  // /** confirmRegOtpOnMobileResponse function used to handle response */
  // confirmRegOtpOnMobileResponse(response)
  // {
  //   console.log('confirmRegOtpOnMobileResponse '+ response.status);
  //   if(response.status==="success")  
  //    {
  //    this.registrationBoxBtn.nativeElement.click();  
  //    this.isLoading=true;
  //    }
  //    else
  //    {
  //    show_okshan_alert(response.reason);
  //    this.isLoading=true;
  //    } 
  // } 

  /** proceedRegistration function used to proceed registration  */
  proceedRegistration(data)
  { 
    if(this.rangeFrom.nativeElement.value.search(";"))
    {
      data.registerationPriceRangeFrom=this.rangeFrom.nativeElement.value.split(";")[0];
    }
    else
    {
    data.registerationPriceRangeFrom=this.rangeFrom.nativeElement.value;
    }
    data.registerationPriceRangeTo=this.rangeTo.nativeElement.value;    
    // const selectedStateIds = this.registerationFormGroup.value.registerationPrefferedState
    //  .map((v, i) => v ? this.registerationPrefferedStatesArray[i].id : null)
    //  .filter(v => v !== null);   

    let selectedStateIds=this.selectedPreferredState.nativeElement.value; 
    selectedStateIds=selectedStateIds.split(',').join('^');
    

     const selectedBrandIds = this.registerationFormGroup.value.registerationBrand
     .map((v, i) => v ? this.registerationBrandsArray[i].id : null)
     .filter(v => v !== null);     

    let formValidated=true;
    let validationError="";
    const formData = new FormData();
    if(this.utilsService.trimming_fn(data.registerationFullName)=="")
    {
      validationError=validationError+"Enter first name<br>";
      formValidated=false;
    }
    // if(this.utilsService.trimming_fn(data.registerationDealerShipName)=="")
    // {
    //   validationError=validationError+"Enter dealership name<br>";
    //   formValidated=false;
    // }
    if(this.utilsService.trimming_fn(data.registerationDealerShipCity)=="0" || this.utilsService.trimming_fn(data.registerationDealerShipCity)==0)
    {
      validationError=validationError+"Select city<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationDealerShipState)=="0" || this.utilsService.trimming_fn(data.registerationDealerShipState)==0)
    {
      validationError=validationError+"Select state<br>";
      formValidated=false;
    }
    
    data.registerationTradeEntity = this.registerationTradeEntity;

    if(this.utilsService.trimming_fn(data.registerationTradeEntity)=="0" || this.utilsService.trimming_fn(data.registerationTradeEntity)==0)
    {
      validationError=validationError+"Select trade entity<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationPin)=="")
    {
      validationError=validationError+"Enter pin<br>";
      formValidated=false;
    }
     if(this.utilsService.trimming_fn(data.registerationAddress)=="")
    {
      validationError=validationError+"Enter address<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationEmail)=="")
    {
      validationError=validationError+"Enter email<br>";
      formValidated=false;
    }
    if(!data.registerationTerm && this.sessionId == 0)
    {
      validationError=validationError+"Accept the terms & privacy policies<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationMobileNo)=="")
    {
      validationError=validationError+"Enter mobile no.<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationPassword)=="")
    {
      validationError=validationError+"Enter password<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationPassword.length)<8)
    {
      validationError=validationError+"Password length must be at least 8 characters<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationConfirmPassword)=="")
    {
      validationError=validationError+"Enter confrim password<br>";
      formValidated=false;
    } 
    if(data.registerationPassword!=data.registerationConfirmPassword)   
    {
      validationError=validationError+"Password and confirm password must be same<br>";
      formValidated=false;
    }
    

    formData.append('first_name',data.registerationFullName);
    formData.append('last_name',data.registerationLastName);
    formData.append('profile_pic','');
    formData.append('dealership_name',data.registerationDealerShipName);
    formData.append('city_id',data.registerationDealerShipCity);
    formData.append('state_id',data.registerationDealerShipState);
    formData.append('pin_code',data.registerationPin);  
    formData.append('email_id',data.registerationEmail);
    formData.append('mobile_no',"+91"+data.registerationMobileNo);
    formData.append('address',data.registerationAddress);
    formData.append('latitude','');
    formData.append('longitude','');
    formData.append('trade_entity',data.registerationTradeEntity);
    if(data.registerationTradeEntity==1 || data.registerationTradeEntity=="1")
    {
    if(this.utilsService.trimming_fn(data.registerationIndName)=="")
    {
      validationError=validationError+"Enter individual name<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationIndPhoneNo)=="")
    {
      validationError=validationError+"Enter individual phone no.<br>";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationIndEmail)=="")
    {
      validationError=validationError+"Enter individual email<br>";
      formValidated=false;
    } 
    
    this.docStatus=0;
    if(this.registerationIndPanFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationIndAadhaarFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationIndPassportFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationIndDLFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationIndVoterFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationIndPhotoFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationIndBusinessProofFile!="") 
    {
      this.docStatus=1;
    }

    if(this.registerationIndPanFile!="" && this.registerationIndAadhaarFile!="" 
    && (this.registerationIndPassportFile!="" || this.registerationIndDLFile!="" || this.registerationIndVoterFile!="") &&
    this.registerationIndPhotoFile!="" && this.registerationIndBusinessProofFile!="")
    {
      this.docStatus=2;
    }

    formData.append('field1',data.registerationIndName);
    formData.append('field2',data.registerationIndPhoneNo);
    formData.append('field3',data.registerationIndAlternateNo);
    formData.append('field4',data.registerationIndEmail);
    formData.append('field5',data.registerationIndPan);
    formData.append('field6',data.registerationIndGstno);
    formData.append('field7','');
    formData.append('field8','');
    formData.append('kyc_doc_1',this.registerationIndPanFile);
    formData.append('kyc_doc_2',this.registerationIndAadhaarFile);
    formData.append('kyc_doc_3',this.registerationIndPassportFile);
    formData.append('kyc_doc_4',this.registerationIndDLFile);
    formData.append('kyc_doc_5',this.registerationIndVoterFile);
    formData.append('kyc_doc_6',this.registerationIndPhotoFile);
    formData.append('kyc_doc_7',this.registerationIndBusinessProofFile);
    formData.append('kyc_doc_8','');
    formData.append('kyc_doc_9','');

    }
    if(data.registerationTradeEntity==2 || data.registerationTradeEntity=="2")
    {
    if(this.utilsService.trimming_fn(data.registerationProTradeName)=="")
    {
      validationError=validationError+"Enter proprietorship trade name<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationProNo)=="")
    {
      validationError=validationError+"Enter proprietorship number<br>";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationProName)=="")
    {
      validationError=validationError+"Enter proprietorship name<br>";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationProEmail)=="")
    {
      validationError=validationError+"Enter proprietorship email<br>";
      formValidated=false;
    }  

    this.docStatus=0;
    if(this.registerationProPanFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationProAadhaarFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationProPassportFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationProDLFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationProVoterFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationProPhotoFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationProBusinessProofFile!="") 
    {
      this.docStatus=1;
    }

    if(this.registerationProPanFile!="" && this.registerationProAadhaarFile!="" 
    && (this.registerationProPassportFile!="" || this.registerationProDLFile!="" || this.registerationProVoterFile!="") &&
    this.registerationProPhotoFile!="" && this.registerationProBusinessProofFile!="")
    {
      this.docStatus=2;
    }

    formData.append('field1',data.registerationProTradeName);
    formData.append('field2',data.registerationProNo);
    formData.append('field3',data.registerationProName);
    formData.append('field4',data.registerationProPhoneNo);
    formData.append('field5',data.registerationProAlternateNo);
    formData.append('field6',data.registerationProEmail);
    formData.append('field7',data.registerationProPan);
    formData.append('field8',data.registerationProGstNo);

    formData.append('kyc_doc_1',this.registerationProPanFile);
    formData.append('kyc_doc_2',this.registerationProAadhaarFile);
    formData.append('kyc_doc_3',this.registerationProPassportFile);
    formData.append('kyc_doc_4',this.registerationProDLFile);
    formData.append('kyc_doc_5',this.registerationProVoterFile);
    formData.append('kyc_doc_6',this.registerationProPhotoFile);
    formData.append('kyc_doc_7',this.registerationProBusinessProofFile);
    formData.append('kyc_doc_8','');
    formData.append('kyc_doc_9','');
    }
    if(data.registerationTradeEntity==3 || data.registerationTradeEntity=="3")
    {
    if(this.utilsService.trimming_fn(data.registerationParName)=="")
    {
      validationError=validationError+"Enter partnership name<br>";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationParPartnerName)=="")
    {
      validationError=validationError+"Enter authorised partner name of partnership<br>";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationParPhoneNo)=="")
    {
      validationError=validationError+"Enter phone no of partnership<br>";
      formValidated=false;
    }

    this.docStatus=0;
    if(this.registerationParPanFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationParGstFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationParBusinessProofFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationParPartnershipProofFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationParPhotoFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationParPan2File!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationParAddressProofFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationParAuthorityLetterFile!="") 
    {
      this.docStatus=1;
    }

    if(this.registerationParPanFile!="" && this.registerationParGstFile!="" && this.registerationParBusinessProofFile!="" 
    && this.registerationParPartnershipProofFile!="" || this.registerationParPhotoFile!="" || this.registerationParPan2File!="" &&
    this.registerationParAddressProofFile!="" && this.registerationParAuthorityLetterFile!="")
    {
      this.docStatus=2;
    }

    formData.append('field1',data.registerationParName);
    formData.append('field2',data.registerationParPartnerName);
    formData.append('field3',data.registerationParPhoneNo);
    formData.append('field4',data.registerationParAlternateNo);
    formData.append('field5',data.registerationParPan);
    formData.append('field6',data.registerationParEmail);
    formData.append('field7','');
    formData.append('field8','');
    formData.append('kyc_doc_1',this.registerationParPanFile);
    formData.append('kyc_doc_2',this.registerationParGstFile);
    formData.append('kyc_doc_3',this.registerationParBusinessProofFile);
    formData.append('kyc_doc_4',this.registerationParPartnershipProofFile);
    formData.append('kyc_doc_5',this.registerationParPhotoFile);
    formData.append('kyc_doc_6',this.registerationParPan2File);
    formData.append('kyc_doc_7',this.registerationParAddressProofFile);
    formData.append('kyc_doc_8',this.registerationParAuthorityLetterFile);
    formData.append('kyc_doc_9','');
    }
    if(data.registerationTradeEntity==4 || data.registerationTradeEntity=="4")
    {
    if(this.utilsService.trimming_fn(data.registerationLimName)=="")
    {
      validationError=validationError+"Enter limited liability partnership name<br>";
      formValidated=false;
    }  
    if(this.utilsService.trimming_fn(data.registerationLimPartnerName)=="")
    {
      validationError=validationError+"Enter authorised partner name of limited liability partnership<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationLimPhoneNo)=="")
    {
      validationError=validationError+"Enter phone number of limited liability partnership<br>";
      formValidated=false;
    } 

    this.docStatus=0;
    if(this.registerationLimPanFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationLimGstFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationLimCertificateFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationLimBusinessProofFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationLimPartnershipProofFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationLimPhotoFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationLimPan2File!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationLimAddressProofFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationLimAuthorityFile!="") 
    {
      this.docStatus=1;
    }

    if(this.registerationLimPanFile!="" && this.registerationLimGstFile!="" && this.registerationLimCertificateFile!="" 
    && this.registerationLimBusinessProofFile!="" || this.registerationLimPartnershipProofFile!="" || this.registerationLimPhotoFile!="" &&
    this.registerationLimPan2File!="" && this.registerationLimAddressProofFile!="" && this.registerationLimAuthorityFile!="")
    {
      this.docStatus=2;
    }

    formData.append('field1',data.registerationLimName);
    formData.append('field2',data.registerationLimPartnerName);
    formData.append('field3',data.registerationLimPhoneNo);
    formData.append('field4',data.registerationLimAlternateNo);
    formData.append('field5',data.registerationLimRocNo);
    formData.append('field6',data.registerationLimRocDate);
    formData.append('field7',data.registerationLimPan);
    formData.append('field8',data.registerationLimGstno);

    formData.append('kyc_doc_1',this.registerationLimPanFile);
    formData.append('kyc_doc_2',this.registerationLimGstFile);
    formData.append('kyc_doc_3',this.registerationLimCertificateFile);
    formData.append('kyc_doc_4',this.registerationLimBusinessProofFile);
    formData.append('kyc_doc_5',this.registerationLimPartnershipProofFile);
    formData.append('kyc_doc_6',this.registerationLimPhotoFile);
    formData.append('kyc_doc_7',this.registerationLimPan2File);
    formData.append('kyc_doc_8',this.registerationLimAddressProofFile);
    formData.append('kyc_doc_9',this.registerationLimAuthorityFile);
    }
    if(data.registerationTradeEntity==5 || data.registerationTradeEntity=="5")
    {
    if(this.utilsService.trimming_fn(data.registerationPriName)=="")
    {
      validationError=validationError+"Enter private limited company trade name <br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationPriPartnerName)=="")
    {
      validationError=validationError+"Enter authorised partner name of private limited company <br>";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationPriPhoneNo)=="")
    {
      validationError=validationError+"Enter phone number of private limited company <br>";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationPriPhoneNo)=="")
    {
      validationError=validationError+"Enter phone number of private limited company <br>";
      formValidated=false;
    } 

    this.docStatus=0;
    if(this.registerationPriPanFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationPriGstFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationPriCertificateFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationPriBusinessProofFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationPriArticlesFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationPriPhotoFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationPripan2File!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationPriAddressProofFile!="") 
    {
      this.docStatus=1;
    }
    if(this.registerationPriResolutionFile!="") 
    {
      this.docStatus=1;
    }

    if(this.registerationPriPanFile!="" && this.registerationPriGstFile!="" && this.registerationPriCertificateFile!="" 
    && this.registerationPriBusinessProofFile!="" || this.registerationPriArticlesFile!="" || this.registerationPriPhotoFile!="" &&
    this.registerationPripan2File!="" && this.registerationPriAddressProofFile!="" && this.registerationPriResolutionFile!="")
    {
      this.docStatus=2;
    }

    formData.append('field1',data.registerationPriName);
    formData.append('field2',data.registerationPriPartnerName);
    formData.append('field3',data.registerationPriPhoneNo);
    formData.append('field4',data.registerationPriAlternateNo);
    formData.append('field5',data.registerationPriRocNo);
    formData.append('field6',data.registerationPriRocDate);
    formData.append('field7',data.registerationPriPanNo);
    formData.append('field8',data.registerationPriGstNo);

    formData.append('kyc_doc_1',this.registerationPriPanFile);
    formData.append('kyc_doc_2',this.registerationPriGstFile);
    formData.append('kyc_doc_3',this.registerationPriCertificateFile);
    formData.append('kyc_doc_4',this.registerationPriBusinessProofFile);
    formData.append('kyc_doc_5',this.registerationPriArticlesFile);
    formData.append('kyc_doc_6',this.registerationPriPhotoFile);
    formData.append('kyc_doc_7',this.registerationPripan2File);
    formData.append('kyc_doc_8',this.registerationPriAddressProofFile);
    formData.append('kyc_doc_9',this.registerationPriResolutionFile);
    }
    formData.append('cancelled_cheque',this.registerationCancelChequeFile);
    //formData.append('preferred_states_sell',selectedStateIds.join("^"));
    formData.append('preferred_states_sell',selectedStateIds);
    formData.append('preferred_states_buy','');
    formData.append('price_range_from',data.registerationPriceRangeFrom);
    formData.append('price_range_to',data.registerationPriceRangeTo);
    formData.append('car_brands',selectedBrandIds.join("^"));
    formData.append('credit_card_holder_name',data.registerationCreditCardName);
    formData.append('credit_card_number',data.registerationCreditCardNo);
    formData.append('credit_card_expiration',data.registerationCreditCardExpiryMonth+"-"+data.registerationCreditCardExpiryYear);
    formData.append('debit_holder_name',data.registerationDebitCardName);
    formData.append('debit_card_number',data.registerationDebitCardno);
    formData.append('expiration',data.registerationDebitCardExpiryMonth+"-"+data.registerationDebitCardExpiryYear);
    formData.append('bank_name',data.registerationBankName);
    formData.append('ifsc_code',data.registerationBankIfsc);
    formData.append('bank_address',data.registerationBankAddress);
    formData.append('bank_account_number',data.registerationBankAccountNo);
    formData.append('profile_type','0');
    formData.append('status','0');
    formData.append('web_device_token','');
    formData.append('mobile_device_token','');
    formData.append('password',btoa(data.registerationPassword));
    
    
    if(formValidated==false)
    {
      show_okshan_alert(validationError);
      return false;
    }
    if(this.sessionProfileType==-1)//join us after request a tour
    {
      formData.append('profile_id',this.sessionId+"");
      this.isLoading=false;  
    this.requestInProcess=true;   
    let result =this.httpserviceService.completeRegistrationRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.registrationResponse(data),
     err => {
       this.requestInProcess=false; 
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })   
    }
    else
    {
    if(this.isOtpConfirmed)  
    {
    this.isLoading=false;  
    this.requestInProcess=true;   
    let result =this.httpserviceService.registrationRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.registrationResponse(data),
     err => {
       this.requestInProcess=false; 
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })
    }
    }
  }

  /** registrationResponse function used to handle response */
  registrationResponse(response)
  {
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     {

     if(this.docStatus==0)
    {
      show_okshan_alert2("You did not upload any documents now, you can upload later on from My Account. Thanks!",6000);
    }
    if(this.docStatus==1)
    {
      show_okshan_alert2("You have uploaded few documents now, remaining you can upload later on from My Account. Thanks!",6000);
    }
    if(this.docStatus==2)
    {
      show_okshan_alert("Thanks for uploading all the documents!");
    }


    setTimeout(() => {    
     this.registerationFormGroup.reset();
     this.registrationBoxCloseBtn.nativeElement.click();    

      this.registerationIndPanFile="";
      this.registerationIndAadhaarFile="";
      this.registerationIndPassportFile="";
      this.registerationIndDLFile="";
      this.registerationIndVoterFile="";
      this.registerationIndPhotoFile="";
      this.registerationIndBusinessProofFile="";
      this.registerationProPanFile="";
      this.registerationProAadhaarFile="";
      this.registerationProPassportFile="";
      this.registerationProDLFile="";
      this.registerationProVoterFile="";
      this.registerationProPhotoFile="";
      this.registerationProBusinessProofFile="";
      this.registerationParPanFile="";
      this.registerationParGstFile="";
      this.registerationParBusinessProofFile="";
      this.registerationParPartnershipProofFile="";
      this.registerationParPhotoFile="";
      this.registerationParPan2File="";
      this.registerationParAddressProofFile="";
      this.registerationParAuthorityLetterFile="";
      this.registerationLimPanFile="";
      this.registerationLimGstFile="";
      this.registerationLimCertificateFile="";
      this.registerationLimBusinessProofFile="";
      this.registerationLimPartnershipProofFile="";
      this.registerationLimPhotoFile="";
      this.registerationLimPan2File="";
      this.registerationLimAddressProofFile="";
      this.registerationLimAuthorityFile="";
      this.registerationPriPanFile="";
      this.registerationPriGstFile="";
      this.registerationPriCertificateFile="";
      this.registerationPriBusinessProofFile="";
      this.registerationPriArticlesFile="";
      this.registerationPriPhotoFile="";
      this.registerationPripan2File="";
      this.registerationPriAddressProofFile="";
      this.registerationPriResolutionFile="";
      this.registerationCancelChequeFile="";
      this.docStatus=0;

      this.requestInProcess=false;

      this.isLoading=true;

      let array=response.details;
     if(array.length>0)
     {
      for(let i=0;i<array.length;i++)
      {
        this.sessionsService.setSession("login_status",true);
        this.sessionsService.setSession("id",array[i].id);
        this.sessionsService.setSession("first_name",array[i].first_name);
        this.sessionsService.setSession("last_name",array[i].last_name);
        this.sessionsService.setSession("profile_pic",array[i].profile_pic); 
        this.sessionsService.setSession("email_id",array[i].email_id);
        this.sessionsService.setSession("mobile_no",array[i].mobile_no);
        this.sessionsService.setSession("dealership_name",array[i].dealership_name);
        this.sessionsService.setSession("profile_type",array[i].profile_type);
        this.sessionsService.setSession("status",array[i].status);
        this.sessionsService.setSession("city_id",array[i].city_id);
        this.sessionsService.setSession("state_id",array[i].state_id);
        window.location.reload();
      }
     }
     }, 3000);
     }
     else
     {
     show_okshan_alert(response.reason);
     this.requestInProcess=false;
     this.isLoading=true;
     } 
  }
  
  registerationIndPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndPanFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationIndPanFile="";
    }
  }
  registerationIndAadhaarFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndAadhaarFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationIndAadhaarFile="";
    }
  }
  registerationIndPassportFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndPassportFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationIndPassportFile="";
    }
  }
  registerationIndDLFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndDLFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationIndDLFile="";
    }
  }
  registerationIndVoterFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndVoterFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationIndVoterFile="";
    }
  }
  registerationIndPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndPhotoFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationIndPhotoFile="";
    }
  }
  registerationIndBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationIndBusinessProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationIndBusinessProofFile="";
    }
  }
registerationProPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProPanFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationProPanFile="";
    }
  }
  registerationProAadhaarFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProAadhaarFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationProAadhaarFile="";
    }
  }
  registerationProPassportFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProPassportFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationProPassportFile="";
    }
  }
  registerationProDLFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProDLFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationProDLFile="";
    }
  }
  registerationProVoterFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProVoterFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationProVoterFile="";
    }
  }
  registerationProPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProPhotoFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationProPhotoFile="";
    }
  }
  registerationProBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationProBusinessProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationProBusinessProofFile="";
    }
  }
registerationParPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParPanFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationParPanFile="";
    }
  }
  registerationParGstFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParGstFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationParGstFile="";
    }
  }
  registerationParBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParBusinessProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationParBusinessProofFile="";
    }
  }
  registerationParPartnershipProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParPartnershipProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationParPartnershipProofFile="";
    }
  }
  registerationParPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParPhotoFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationParPhotoFile="";
    }
  }
  registerationParPan2FileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParPan2File= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationParPan2File="";
    }
  }
  registerationParAddressProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParAddressProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationParAddressProofFile="";
    }
  }
  registerationParAuthorityLetterFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationParAuthorityLetterFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationParAuthorityLetterFile="";
    }
  }
registerationLimPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimPanFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationLimPanFile="";
    }
  }
  registerationLimGstFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimGstFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationLimGstFile="";
    }
  }
  registerationLimCertificateFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimCertificateFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationLimCertificateFile="";
    }
  }
  registerationLimBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimBusinessProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationLimBusinessProofFile="";
    }
  }
  registerationLimPartnershipProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimPartnershipProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationLimPartnershipProofFile="";
    }
  }
  registerationLimPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimPhotoFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationLimPhotoFile="";
    }
  }
  registerationLimPan2FileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimPan2File= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationLimPan2File="";
    }
  }
  registerationLimAddressProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimAddressProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationLimAddressProofFile="";
    }
  }
  registerationLimAuthorityFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationLimAuthorityFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationLimAuthorityFile="";
    }
  }

registerationPriPanFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriPanFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationPriPanFile="";
    }
  }
  registerationPriGstFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriGstFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationPriGstFile="";
    }
  }
  registerationPriCertificateFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriCertificateFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationPriCertificateFile="";
    }
  }
  registerationPriBusinessProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriBusinessProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationPriBusinessProofFile="";
    }
  }
  registerationPriArticlesFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriArticlesFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationPriArticlesFile="";
    }
  }
  registerationPriPhotoFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriPhotoFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationPriPhotoFile="";
    }
  }
  registerationPripan2FileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPripan2File= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationPripan2File="";
    }
  }
  registerationPriAddressProofFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriAddressProofFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationPriAddressProofFile="";
    }
  }
  registerationPriResolutionFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationPriResolutionFile= file;
      //});
      show_joinus_preference_input();
    }
    else{
       this.registerationPriResolutionFile="";
    }
  }

  registerationCancelChequeFileChange(event) {
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      //this.registerationFormGroup.patchValue({
        this.registerationCancelChequeFile= file;
      //});
    }
    else{
       this.registerationCancelChequeFile="";
    }
  }

  /** proceedCredentialsLogin function used to proceed credentials login*/   
  proceedCredentialsLogin(data)
  {
    console.log('proceedCredentialsLogin '+ this.loginCredentialsFormGroup.valid);
     if(this.loginCredentialsFormGroup.valid)
     {     
     this.isLoading=false;  
     this.httpserviceService.credentialsLoginRequest(data.loginCredentialsUser,data.loginCredentialsPassword).
     pipe(retry(0)).
     subscribe((data)=>this.credentialsLoginResponse(data),
     err => {
       show_okshan_alert('Something went wrong');
       console.log('Something went wrong', err);
       this.isLoading=true;
            })
     }
    }
  

  /** credentialsLoginResponse function used to handle credentials login response */
  credentialsLoginResponse(response)
  {
    console.log('credentialsLoginResponse '+ response.status);
    if(response.status.toUpperCase()==="SUCCESS")  
     {           
     let array=response.details;
     if(array.length>0)
     {
      for(let i=0;i<array.length;i++)
      {
        this.sessionsService.setSession("login_status",true);
        this.sessionsService.setSession("id",array[i].id);
        this.sessionsService.setSession("first_name",array[i].first_name);
        this.sessionsService.setSession("last_name",array[i].last_name);
        this.sessionsService.setSession("profile_pic",array[i].profile_pic); 
        this.sessionsService.setSession("email_id",array[i].email_id);
        this.sessionsService.setSession("mobile_no",array[i].mobile_no);
        this.sessionsService.setSession("dealership_name",array[i].dealership_name);
        this.sessionsService.setSession("profile_type",array[i].profile_type);
        this.sessionsService.setSession("status",array[i].status);
        this.sessionsService.setSession("city_id",array[i].city_id);
        this.sessionsService.setSession("state_id",array[i].state_id);
        this.sessionsService.setSession("password",array[i].password);
        this.loginModalCloseBtn.nativeElement.click(); 
        window.location.href="#/home";
      } 
     }
     this.isLoading=true; 
     }
     else
     {
     show_okshan_alert(response.reason);
     this.isLoading=true;
     } 
  }  
  
  /** proceedSendMobileLoginOTP function used to proceed send mobile login otp*/   
  proceedSendMobileLoginOTP(data)
  {
     if(!this.loginMobileNoFormGroup.get('loginMobileNo').errors){ 
     this.loginMobileNoSendOtpBtnLbl="Resend OTP";
     this.isLoading=false;
     this.httpserviceService.sendLoginOtpOnMobileNoRequest("+91"+data.loginMobileNo).
     pipe(retry(0)).
     subscribe((data)=>this.sendLoginOtpOnMobileNoResponse(data),
     err => {
       show_okshan_alert('Something went wrong');
       console.log('Something went wrong', err);
       this.isLoading=true;
    })
     }
  }

  /** sendLoginOtpOnMobileNoResponse function used to send login otp on mobile */
  sendLoginOtpOnMobileNoResponse(response)
  {
    console.log('sendRegOtpOnMobileNoResponse '+ response.status);
    if(response.status==="success")  
     {
     this.isLoading=true; 
     this.openLoginMobileOtpConfirmBoxBtn.nativeElement.click();
     }
     else
     {
     show_okshan_alert(response.reason);
     this.isLoading=true;
     } 
  }

  /** proceedConfirmLoginOtpOnMobile function used to proceed confirm login otp on mobile  */
  proceedConfirmLoginOtpOnMobile(data)
  {
     if(!this.loginMobileNoFormGroup.get('loginMobileNoOtp').errors)
     this.isLoading=false;
     let result =this.httpserviceService.confirmLoginOtpOnMobileRequest("+91"+data.loginMobileNo,data.loginMobileNoOtp).
     pipe(retry(0)).
     subscribe((data)=>this.confirmLoginOtpOnMobileResponse(data),
     err => {
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })       
  }
  

  /** confirmLoginOtpOnMobileResponse function used to handle response */
  confirmLoginOtpOnMobileResponse(response)
  {
    console.log('confirmLoginOtpOnMobileResponse '+ response.status);
    if(response.status.toUpperCase()==="SUCCESS")  
     {  

     let array=response.details;
     if(array.length>0)
     {
      for(let i=0;i<array.length;i++)
      {
        this.sessionsService.setSession("login_status",true);
        this.sessionsService.setSession("id",array[i].id);
        this.sessionsService.setSession("first_name",array[i].first_name);
        this.sessionsService.setSession("last_name",array[i].last_name);
        this.sessionsService.setSession("profile_pic",array[i].profile_pic); 
        this.sessionsService.setSession("email_id",array[i].email_id);
        this.sessionsService.setSession("mobile_no",array[i].mobile_no);
        this.sessionsService.setSession("dealership_name",array[i].dealership_name);
        this.sessionsService.setSession("profile_type",array[i].profile_type);
        this.sessionsService.setSession("status",array[i].status);
        this.sessionsService.setSession("city_id",array[i].city_id);
        this.sessionsService.setSession("state_id",array[i].state_id); 
        this.loginModalCloseBtn.nativeElement.click(); 
        window.location.href="#/home";
      } 
     }
     this.isLoading=true; 
     }
     else
     {
     show_okshan_alert(response.reason);
     this.isLoading=true;
     } 
  }

   /** resetForm function used to reset join us form */
   resetJoinUsForm()
   {
     //show_okshan_alert("called 2");
     this.regMobileNoFormdata.reset();
     this.loginCredentialsFormGroup.reset();
     this.loginMobileNoFormGroup.reset();
     this.registerationFormGroup.reset();
   }

  /** sendVisitorRegOtpOnMobile function used to send visitor registration otp on mobile*/   
  proceedRegOtpOnMobile(data)
  { 
     if(this.getOtpTryCount==3)
     {
        this.eventStatusMsg="Get otp has been reached on limit 3. Try after some time";        
        setTimeout(() => {
        this.getOtpTryCount=0;   
        }, 30*60*1000);
        return false;
     }    
     if(!this.registerationFormGroup.get('registerationMobileNo').errors){      
     //this.isLoading=false;
     this.eventStatusMsg="Sending otp on mobile";
     this.httpserviceService.sendRegOtpOnMobileNo("+91"+data.registerationMobileNo).
     pipe(retry(0)).
     subscribe((data)=>this.sendRegOtpOnMobileResponse(data),
     err => {
       this.eventStatusMsg="Something went wrong !"; 
       console.log('Something went wrong', err);
       this.isLoading=true;
    })
     }
  }

 /** sendVisitorRegOtpOnMobileResponse function used to handle response */
  sendRegOtpOnMobileResponse(response)
  {
    console.log('sendVisitorRegOtpOnMobileResponse '+ response.status);
    if(response.status==="success")  
     {
     //this.isLoading=true; 
     this.getOtpTryCount++;
     this.eventStatusMsg="Otp has been sent";
     this.getOtpBtnStatus=false;
     setTimeout(() => {
     this.getOtpBtnStatus=true;   
     }, 120000);
     this.startCountdown(120);
     }
     else
     {
     this.eventStatusMsg=response.reason;
     //this.isLoading=true;
     } 
  }

  /** proceedConfirmRegOtpOnMobile function used to confirm visitor registration otp  */
  proceedConfirmRegOtpOnMobile(data)
  {

     if(!this.registerationFormGroup.get('registerationMobileNo').errors && !this.registerationFormGroup.get('regMobileOtp').errors){ 
     //this.isLoading=false;
     this.eventStatusMsg="Verifying  otp...";
     let result =this.httpserviceService.confirmRegOtpOnMobileNo2("+91"+data.registerationMobileNo,data.regMobileOtp).
     pipe(retry(0)).
     subscribe((data)=>this.confirmRegOtpOnMobileResponse(data),
     err => {
       this.eventStatusMsg="Something went wrong !";
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })       
  }
  }

  /** confirmRegOtpOnMobileResponse function used to handle response */
  confirmRegOtpOnMobileResponse(response)
  {
    console.log('confirmRegOtpOnMobileResponse '+ response.status);
    if(response.status==="success")  
     {
     this.counter=0;  
     this.isOtpConfirmed=true;   
     this.eventStatusMsg="";
     }
     else
     {
     show_okshan_alert(response.reason);
     this.otpConfimedLabel=response.reason;
     this.eventStatusMsg="";
     //this.isLoading=true;
     } 
  }

  /** startCountdown used to  start count down after otp sent  */
  startCountdown(seconds) {
  this.counter = seconds;
    
  const interval = setInterval(() => {
    if (this.counter == 0 ) {
      clearInterval(interval);
      console.log('Ding!');
    }
    this.counter--; 
    this.counterLabel=Math.floor(this.counter/60)+":"+Math.floor(this.counter%60);   
  }, 1000);
}

/** getStateList function used to get states list */ 
  getStateList()
  {    
    let result =this.httpserviceService.getStateListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getStateListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getStateListResponse function used to handle response */
  getStateListResponse(response)
  {   
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.sessionsService.setSession("state_list",response.list);
       this.stateList=response.list;
       this.registerationPrefferedStatesArray=response.list;       
       this.registerationPrefferedStatesArray.forEach((o, i) => {
const control = new FormControl(false); // if first item set to true, else false
(this.registerationFormGroup.controls.registerationPrefferedState as FormArray).push(control);
});
    setTimeout(() => {
    if(this.sessionStateId>0)
    {
    this.registerationFormGroup.controls['registerationDealerShipState'].setValue(this.sessionStateId);
    }  
    }, 200);  

    for(let i=0;i<this.stateList.length;i++)
{
  if(this.stateList[i].preferred==1)
  {
    this.preferredStateList.push(this.stateList[i]);
    this.preferredStateIds=this.preferredStateIds+"^"+this.stateList[i].id+"^";
  }
  else
  {
    this.otherStateList.push(this.stateList[i]);
  }
}
setTimeout(() => {
set_multi_select();
}, 200);

     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** getStateCityList function used to get states cities list */ 
  getStateCityList()
  { 
    let result =this.httpserviceService.getStateCityListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getStateCityListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getStateListResponse function used to handle response */
  getStateCityListResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.sessionsService.setSession("state_city_list",response.list); 
       this.onChangeState(this.sessionStateId);
       setTimeout(() => {
       if(this.sessionCityId>0)
       {
       this.registerationFormGroup.controls['registerationDealerShipCity'].setValue(this.sessionCityId);   
       }  
       }, 200);                       
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** getBrandList function used to get brand list */ 
  getBrandList()
  { 
    let result =this.httpserviceService.getBrandListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getBrandListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getBrandListResponse function used to handle response */
  getBrandListResponse(response)
  {    
    console.log('getBrandListResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.sessionsService.setSession("brand_list",response.list);
       this.registerationBrandsArray=response.list;
       this.registerationBrandsArray.forEach((o, i) => {
      const control = new FormControl(false); // if first item set to true, else false
      (this.registerationFormGroup.controls.registerationBrand as FormArray).push(control);
      });       
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** onChangeState function used to perform event on state change */
  onChangeState(value)
  {
   if(value!=0 && this.preferredStateIds!="" && this.preferredStateIds.indexOf("^"+value+"^")<0 && this.setStateChangeStatus)
   {
     show_okshan_alert3("We are currently not operational in this state, however you are welcome to submit your details and we will enroll you as soon as possible");
   } 
   let list=this.sessionsService.getSession("state_city_list"); 
   this.cityList=list[value];   
  }

  /** getAllBrandList function used to get all brand list */ 
  getAllBrandList()
  { 
    let result =this.httpserviceService.getAllBrandListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getAllBrandListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getAllBrandListResponse function used to handle response */
  getAllBrandListResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.sessionsService.setSession("all_brand_list",response.list);                    
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** getAllModelList function used to get all model list */ 
  getAllModelList()
  { 
    let result =this.httpserviceService.getAllModelListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getAllModelListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getAllModelListResponse function used to handle response */
  getAllModelListResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.sessionsService.setSession("all_model_list",response.list);                 
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** getAllVariantList function used to get all variant list */ 
  getAllVariantList()
  { 
    let result =this.httpserviceService.getAllVariantListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getAllVariantListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getAllVariantListResponse function used to handle response */
  getAllVariantListResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.sessionsService.setSession("all_variant_list",response.list);                    
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** getAllCityList function used to get all cities list */ 
  getAllCityList()
  { 
    let result =this.httpserviceService.getAllCityListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getAllCityListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getAllStateListResponse function used to handle response */
  getAllCityListResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.sessionsService.setSession("all_city",response.list);       
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

/** getAllStateList function used to get all states list */ 
  getAllStateList()
  { 
    let result =this.httpserviceService.getAllStateListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getAllStateListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getAllStateListResponse function used to handle response */
  getAllStateListResponse(response)
  {    
    console.log('registrationResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.sessionsService.setSession("all_state",response.list);
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** getFuelTypeList function used to get fuel type list */ 
  getFuelTypeList()
  { 
    let result =this.httpserviceService.getFuelTypeListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getFuelTypeListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getBrandModelListResponse function used to handle response */
  getFuelTypeListResponse(response)
  {    
    console.log('getBrandModelListResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.sessionsService.setSession("fuel_type",response.list1);
       this.sessionsService.setSession("all_fuel_type",response.list2); 
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }
  
/** getFuelTypeList function used to get fuel type list */ 
  getAllTypeList()
  { 
    let result =this.httpserviceService.getAllTypeListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getAllTypeListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getBrandModelListResponse function used to handle response */
  getAllTypeListResponse(response)
  {    
    console.log('getAllTypeListResponse '+ response.status);
    if(response.status==="success")  
     { 
        this.sessionsService.setSession('all_brand_list',response.brand_list)
        this.sessionsService.setSession('all_model_list',response.model_list)
        this.sessionsService.setSession('all_variant_list',response.variant_list)
        this.sessionsService.setSession('all_city',response.city_list)
        this.sessionsService.setSession('all_state',response.state_list)
        this.sessionsService.setSession('all_fuel_type',response.fuel_type_list)       
       //this.sessionsService.setSession("fuel_type",response.list1);
       //this.sessionsService.setSession("all_fuel_type",response.list2); 
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** onchangeEntityType function used to perform operation on entity change */
  onchangeEntityType(type)
  {
    if(type=='1' || type==1)
    {
      this.registerationFormGroup.controls['registerationIndName'].setValue(this.registerationFormGroup.controls['registerationFullName'].value+" "+this.registerationFormGroup.controls['registerationLastName'].value);
      this.registerationFormGroup.controls['registerationIndPhoneNo'].setValue(this.registerationFormGroup.controls['registerationMobileNo'].value);
      this.registerationFormGroup.controls['registerationIndEmail'].setValue(this.registerationFormGroup.controls['registerationEmail'].value);
    }
    if(type=='2'  || type==2)
    {
      this.registerationFormGroup.controls['registerationProName'].setValue(this.registerationFormGroup.controls['registerationFullName'].value+" "+this.registerationFormGroup.controls['registerationLastName'].value);
      this.registerationFormGroup.controls['registerationProPhoneNo'].setValue(this.registerationFormGroup.controls['registerationMobileNo'].value);
      this.registerationFormGroup.controls['registerationProEmail'].setValue(this.registerationFormGroup.controls['registerationEmail'].value);
    }
    if(type=='3' || type==3)
    {
      // this.registerationFormGroup.controls['registerationParName'].setValue(this.registerationFormGroup.controls['registerationFullName'].value+" "+this.registerationFormGroup.controls['registerationLastName'].value);
      this.registerationFormGroup.controls['registerationParPhoneNo'].setValue(this.registerationFormGroup.controls['registerationMobileNo'].value);
      this.registerationFormGroup.controls['registerationParEmail'].setValue(this.registerationFormGroup.controls['registerationEmail'].value);
    }
    if(type=='4' || type==4)
    {
      // this.registerationFormGroup.controls['registerationLimName'].setValue(this.registerationFormGroup.controls['registerationFullName'].value+" "+this.registerationFormGroup.controls['registerationLastName'].value);
      this.registerationFormGroup.controls['registerationLimPhoneNo'].setValue(this.registerationFormGroup.controls['registerationMobileNo'].value);
    }
    if(type=='5' || type==5)
    {
      // this.registerationFormGroup.controls['registerationPriName'].setValue(this.registerationFormGroup.controls['registerationFullName'].value);
      this.registerationFormGroup.controls['registerationPriPhoneNo'].setValue(this.registerationFormGroup.controls['registerationMobileNo'].value);
    }
    if(type == 0) {
      this.registerationTradeEntity = "";
    } else {
     this.registerationTradeEntity = type;
    }
  }


  /** proceedRegistration function used to proceed registration  */
  proceedSkipKycRegistration(data)
  { 
     let formValidated=true;
    let validationError="";      
    if(this.utilsService.trimming_fn(data.registerationMobileNo)=="")
    {
      validationError=validationError+"Enter mobile no.<br>";
      formValidated=false;
    } 
    if(this.utilsService.trimming_fn(data.registerationFullName)=="")
    {
      validationError=validationError+"Enter first name<br>";
      formValidated=false;
    }
    // if(this.utilsService.trimming_fn(data.registerationDealerShipName)=="")
    // {
    //   validationError=validationError+"Enter dealership name<br>";
    //   formValidated=false;
    // }
    if(this.utilsService.trimming_fn(data.registerationDealerShipState)=="0" || this.utilsService.trimming_fn(data.registerationDealerShipState)==0)
    {
      validationError=validationError+"Select state<br>";
      formValidated=false;
    }
    if(this.utilsService.trimming_fn(data.registerationDealerShipCity)=="0" || this.utilsService.trimming_fn(data.registerationDealerShipCity)==0)
    {
      validationError=validationError+"Select city<br>";
      formValidated=false;
    }    
    if(this.utilsService.trimming_fn(data.registerationEmail)=="")
    {
      validationError=validationError+"Enter email<br>";
      formValidated=false;
    }
    if(!data.registerationTerm)
    {
      validationError=validationError+"Accept the terms & privacy policies<br>";
      formValidated=false;
    }  
    let formData=new FormData();   
    formData.append('first_name',data.registerationFullName);
    formData.append('last_name',data.registerationLastName);
    formData.append('profile_pic','');
    formData.append('dealership_name',data.registerationDealerShipName);
    formData.append('city_id',data.registerationDealerShipCity);
    formData.append('state_id',data.registerationDealerShipState);
    formData.append('pin_code','');  
    formData.append('email_id',data.registerationEmail);
    formData.append('mobile_no',"+91"+data.registerationMobileNo);
    formData.append('address','');
    formData.append('latitude','');
    formData.append('longitude','');
    formData.append('trade_entity',"0");    
    formData.append('field1','');
    formData.append('field2','');
    formData.append('field3','');
    formData.append('field4','');
    formData.append('field5','');
    formData.append('field6','');
    formData.append('field7','');
    formData.append('field8','');
    formData.append('kyc_doc_1','');
    formData.append('kyc_doc_2','');
    formData.append('kyc_doc_3','');
    formData.append('kyc_doc_4','');
    formData.append('kyc_doc_5','');
    formData.append('kyc_doc_6','');
    formData.append('kyc_doc_7','');
    formData.append('kyc_doc_8','');
    formData.append('kyc_doc_9','');    
    formData.append('cancelled_cheque','');
    formData.append('preferred_states_sell','');
    formData.append('preferred_states_buy','');
    formData.append('price_range_from',"0");
    formData.append('price_range_to',"0");
    formData.append('car_brands','');
    formData.append('credit_card_holder_name','');
    formData.append('credit_card_number','');
    formData.append('credit_card_expiration','');
    formData.append('debit_holder_name','');
    formData.append('debit_card_number','');
    formData.append('expiration','');
    formData.append('bank_name','');
    formData.append('ifsc_code','');
    formData.append('bank_address','');
    formData.append('bank_account_number','');
    formData.append('profile_type','-1');
    formData.append('status','0');
    formData.append('web_device_token','');
    formData.append('mobile_device_token','');
    formData.append('password','');

    if(formValidated==false)
    {
      show_okshan_alert(validationError);
      return false;
    }
if(this.isOtpConfirmed)  
    {
    this.isLoading=false;  
    this.requestInProcess=true;   
    let result =this.httpserviceService.registrationRequest(formData).
     pipe(retry(0)).
     subscribe((data)=>this.SkipKycRegistrationResponse(data),
     err => {
       this.requestInProcess=false; 
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })
    }
  }

  /** SkipKycRegistrationResponse function used to registration after skip kyc doc */
  SkipKycRegistrationResponse(response)
  {
    console.log('SkipKycRegistrationResponse '+ response.status);
    if(response.status==="success")  
     {      
     //this.resetVisitorRegForm();
     //this.visitorRegBoxCloseBtn.nativeElement.click();  
     this.isLoading=true;
     let array=response.details;
     if(array.length>0)
     {
      for(let i=0;i<array.length;i++)
      {
        this.sessionsService.setSession("login_status",true);
        this.sessionsService.setSession("id",array[i].id);
        this.sessionsService.setSession("first_name",array[i].first_name);
        this.sessionsService.setSession("last_name",array[i].last_name);
        this.sessionsService.setSession("profile_pic",array[i].profile_pic); 
        this.sessionsService.setSession("email_id",array[i].email_id);
        this.sessionsService.setSession("mobile_no",array[i].mobile_no);
        this.sessionsService.setSession("dealership_name",array[i].dealership_name);
        this.sessionsService.setSession("profile_type",array[i].profile_type);
        this.sessionsService.setSession("status",array[i].status);
        this.sessionsService.setSession("city_id",array[i].city_id);
        this.sessionsService.setSession("state_id",array[i].state_id);        
        window.location.href="#/home";
      } 
     }
     }
     else
     {
     show_okshan_alert(response.reason);
     this.requestInProcess=false;
     this.isLoading=true;
     } 
  }

  showAlert(msg)
  {
    show_okshan_alert(msg);
  }

  visitorcContactUs()
  {
     this.router.navigate(['visitor-contactus']);
  }

  about()
  {
     this.router.navigate(['about']);
  }

  setStateChange()
  {
    this.setStateChangeStatus=true;
  }

  /** showSelectedStateCity function used to show selected state and city */
  showSelectedStateCity()
  {
    this.selectedState=this.sessionsService.getSession("all_state")[this.registerationFormGroup.controls['registerationDealerShipState'].value];
    this.selectedCity=this.sessionsService.getSession("all_city")[this.registerationFormGroup.controls['registerationDealerShipCity'].value];
  }

  privacyPolicy()
  {
    this.router.navigate(['privay-policy']);
  }
  termCondition()
  {
    this.router.navigate(['term-condition']);
  }

  /** proceedChangePasswordLinkRequest function used to proceed change password request  */
  proceedChangePasswordLinkRequest(data)
  {
      this.isSubmitForgotPassword=true;
     if(this.forgotPasswordFormGroup.valid){ 
     this.forgotPasswordBTNLabel="Sending..."
     let body = { email_id: data.forgotPasswordEmailId};
     let result =this.httpserviceService.changePasswordLinkRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.changePasswordLinkResponse(data),
     err => {
       this.forgotPasswordBTNLabel="Send"
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);
       this.isLoading=true;
    })       
  }
  }

  /** changePasswordLinkResponse function used to handle response */
  changePasswordLinkResponse(response)
  {
    console.log('changePasswordLinkResponse '+ response.status);
    if(response.status==="success")  
     {     
     show_okshan_alert3("Reset password link has been sent on your email");
     this.forgotPasswordFormGroup.controls['forgotPasswordEmailId'].setValue('');
     this.forgotPasswordBTNLabel="Send"
     this.isSubmitForgotPassword=true;
     }
     else
     {
     show_okshan_alert3(response.reason);
     this.forgotPasswordBTNLabel="Send"
     } 
  }

}


